function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["status"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo } from 'react';
import { sortBy } from 'lodash';
import { _PageContainer, _TimelineContainer } from "./style";
import useStudentRecords from "./hooks/useStudentRecords";
import TimelineRow from "./TimelineRow";
import Loading from "../../../components/core/ui/Loading";
import { WaitForApplicationData } from "../ApplicationDataLoader";
function getStatusText(status) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var statusMap = {
    Rejected: 'Application has been rejected',
    Undecided: 'Application decision is pending',
    Reactivated: null,
    Cancelled: 'Application has been cancelled',
    Uncancelled: null,
    Withdrawn: 'Application has been withdrawn',
    'Application Created': null,
    'Ready to Submit': null,
    'Submit Rollback': null,
    Submitted: 'Application has been submitted',
    'Submitted Rollback': null,
    Accepted: "Congratulations, ".concat(name, " has received an acceptance"),
    'Ready For Visa': 'Application is now ready for visa',
    'Ready For Visa Rollback': null,
    'Program Closed': 'Program is no longer available',
    Waitlisted: 'Application has been placed on the school waitlist',
    'Refund in Progress': 'Refund is in progress',
    'Refund in Progress Rollback': 'The application is no longer in the refund process.',
    'Deferral in Progress': 'Deferral is in progress',
    'Deferral in Progress Rollback': 'The application is no longer in the deferral process.',
    'Ready to Enroll': 'Application is now ready to enroll',
    'Ready to Enroll Rollback': null,
    'Enrollment Confirmed': "Congratulations, ".concat(name, " enrollment has been confirmed"),
    'Enrollment Confirmed Rollback': null
  };
  return statusMap[status];
}
function filterStatusChanges(statusChanges, application) {
  var _application$applicat, _application$applicat2, _application$applicat3;
  var personalInformation = application === null || application === void 0 ? void 0 : (_application$applicat = application.application) === null || _application$applicat === void 0 ? void 0 : (_application$applicat2 = _application$applicat.student) === null || _application$applicat2 === void 0 ? void 0 : _application$applicat2.personal_information;
  var firstName = personalInformation && personalInformation.first_name ? personalInformation.first_name : '';
  var middleName = personalInformation && personalInformation.middle_name ? personalInformation.middle_name : '';
  var lastName = personalInformation && personalInformation.last_name ? personalInformation.last_name : '';
  var studentName = "".concat(firstName, " ").concat(middleName, " ").concat(lastName);
  var applicationId = application === null || application === void 0 ? void 0 : (_application$applicat3 = application.application) === null || _application$applicat3 === void 0 ? void 0 : _application$applicat3.id;
  var filteredStatusChanges = Array.isArray(statusChanges) ? statusChanges.filter(function (status) {
    return status.application_id === applicationId && getStatusText(status.status, studentName);
  }) : [];
  return filteredStatusChanges.map(function (_ref) {
    var status = _ref.status,
      other = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread({
      status: getStatusText(status, studentName)
    }, other);
  });
}
function StudentRecordsContent() {
  var _useStudentRecords = useStudentRecords(),
    documents = _useStudentRecords.documents,
    receipts = _useStudentRecords.receipts,
    payments = _useStudentRecords.payments,
    questions = _useStudentRecords.questions,
    disclaimers = _useStudentRecords.disclaimers,
    application = _useStudentRecords.application,
    statusChanges = _useStudentRecords.statusChanges,
    isLoading = _useStudentRecords.isLoading;
  var sortedRecords = useMemo(function () {
    var _application$applicat4, _application$applicat5, _application$applicat6, _application$applicat7, _application$applicat8;
    var temporaryRows = [];
    documents.forEach(function (document) {
      if (document.required_state !== 'required_state_inactive') {
        temporaryRows.push({
          id: document.id,
          type: 'documentRequirement',
          requirement: document,
          date: new Date(document.completed_at),
          position: 'middle'
        });
      }
    });
    receipts.forEach(function (receipt) {
      return temporaryRows.push({
        id: receipt.id,
        type: 'receiptRequirement',
        requirement: receipt,
        date: new Date(receipt.completed_at),
        position: 'middle'
      });
    });
    payments.forEach(function (payment) {
      return temporaryRows.push({
        id: payment.id,
        type: 'paymentRequirement',
        requirement: payment,
        date: new Date(payment.completed_at),
        position: 'middle'
      });
    });
    questions.forEach(function (question) {
      return temporaryRows.push({
        id: question.id,
        type: 'questionRequirement',
        requirement: question,
        date: new Date(question.completed_at),
        position: 'middle'
      });
    });
    disclaimers === null || disclaimers === void 0 ? void 0 : disclaimers.forEach(function (disclaimer) {
      return temporaryRows.push({
        id: disclaimer.id,
        type: 'disclaimerRequirement',
        requirement: disclaimer,
        date: new Date(disclaimer.completed_at),
        position: 'middle'
      });
    });
    filterStatusChanges(statusChanges, application).forEach(function (status) {
      return temporaryRows.push({
        id: status.id,
        type: 'applicationStatus',
        status: status.status,
        date: new Date(status.updated_at),
        position: 'middle'
      });
    });
    application === null || application === void 0 ? void 0 : (_application$applicat4 = application.application) === null || _application$applicat4 === void 0 ? void 0 : (_application$applicat5 = _application$applicat4.application_record_events) === null || _application$applicat5 === void 0 ? void 0 : _application$applicat5.forEach(function (record) {
      temporaryRows.push({
        type: record.event_type,
        date: new Date(record.created_at),
        position: 'middle',
        status: record.message,
        attributes: record.attributes
      });
    });
    var rows = sortBy(temporaryRows, ['date']).reverse();
    rows.forEach(function (row, i) {
      // eslint-disable-next-line no-param-reassign
      row.position = i === 0 ? 'top' : 'middle';
    });
    if (!rows.length) {
      rows.push({
        id: 'empty',
        type: 'empty',
        position: 'top'
      });
    }
    rows.push({
      id: 'base',
      type: 'base',
      acceptedStatus: ((_application$applicat6 = application.application.status) === null || _application$applicat6 === void 0 ? void 0 : _application$applicat6.accepted) || (application === null || application === void 0 ? void 0 : (_application$applicat7 = application.application) === null || _application$applicat7 === void 0 ? void 0 : (_application$applicat8 = _application$applicat7.status) === null || _application$applicat8 === void 0 ? void 0 : _application$applicat8.ready_for_visa),
      updatedAt: (application === null || application === void 0 ? void 0 : application.application) && new Date(application.application.updated_at),
      date: (application === null || application === void 0 ? void 0 : application.application) && new Date(application.application.created_at),
      position: 'bottom'
    });
    return rows;
  }, [documents, questions, disclaimers, receipts, payments, application]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(_PageContainer, null, /*#__PURE__*/React.createElement(Loading, null));
  }
  return /*#__PURE__*/React.createElement("div", {
    "walkme-id": "applications-studentrecords"
  }, /*#__PURE__*/React.createElement(_PageContainer, null, /*#__PURE__*/React.createElement(_TimelineContainer, null, sortedRecords.map(function (row) {
    return /*#__PURE__*/React.createElement(TimelineRow, {
      key: "".concat(row.type, "-").concat(row.id),
      row: row
    });
  }))));
}
export default function StudentRecords() {
  return /*#__PURE__*/React.createElement(WaitForApplicationData, null, /*#__PURE__*/React.createElement(StudentRecordsContent, null));
}